import { LOCALE_SUBDIRECTORY_MAPPING } from './constants';
import { canUseDOM } from '@marriott/mi-ui-library';
import { SavedProperty } from './PropertyBar.types';
export const SHOW_HOTEL_DETAIL_EVENT = 'showHotelDetail';

export function getSavedProperties(propertyId: string, savedProperties: SavedProperty[]) {
  const properties = [...savedProperties];
  const propertyAt = properties?.findIndex((property: SavedProperty) => property.id === propertyId);
  propertyAt !== -1 ? properties?.splice(propertyAt, 1) : properties?.push({ id: propertyId });
  return properties.map(({ id }) => ({ id }));
}

export function hasSavedProperty(propertyId: string, savedProperties: SavedProperty[]) {
  return !!savedProperties?.findIndex((property: SavedProperty) => property.id === propertyId);
}

export const getSubDirectoryLocale = (currentLocale: string): string => {
  const subDirectory = LOCALE_SUBDIRECTORY_MAPPING[currentLocale];
  return subDirectory || '';
};
export const eventUtil = {
  on(event: string, callback: (data: unknown) => void) {
    canUseDOM && document.addEventListener(event, e => callback((e as CustomEvent).detail));
  },
  dispatch(event: string, data: unknown) {
    canUseDOM && document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event: string, callback: (data: unknown) => void) {
    canUseDOM && document.removeEventListener(event, callback as EventListener);
  },
};
